import React from "react";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { toast } from "react-toastify";
import moment from "moment";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { EditIcon, DeleteIcon } from "../../images/icons/website-icons";
import { fetchApiData } from "../../redux/reducers/commonApiSlice";
import "../../styles/tracking-system/break-rules.css";
import { trackingSystemBreakRules } from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";

const BreakRules = ({
  userInfoData,
  breakRulesData,
  breakRulesLoading,
  refetchBreakRules,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  onEditBreak,
}) => {
  console.log("pageLimit", pageLimit);

  const dispatch = useDispatch();

  // Handle delete operation
  const handleDelete = async (uid, name) => {
    const handleConfirm = async () => {
      try {
        const response = await dispatch(
          fetchApiData({
            endpoint: `${trackingSystemBreakRules}/${uid}`,
            method: "DELETE",
            token: userInfoData?.token,
          })
        ).unwrap();

        if (response) {
          toast.success("Break rule deleted successfully!");
          refetchBreakRules();
        }
      } catch (error) {
        console.error("Error deleting break rule:", error);
        toast.error(error?.message || "Failed to delete break rule");
      }
    };
    showConfirmAlert(
      handleConfirm,
      `Are you sure you want to delete "${name}" break rule?`
    );
  };

  const breakRulesColumns = [
    {
      dataField: "name",
      text: <p className="table__header">Break Name</p>,
      formatter: (cell, row) => {
        return (
          <div className="break-name-cell">
            <p className="tb-data table__Text font-weight-bold">{row?.name}</p>
            {row?.description && (
              <small className="text-muted">{row.description}</small>
            )}
          </div>
        );
      },
    },
    {
      dataField: "duration",
      text: <p className="table__header">Duration</p>,
      formatter: (cell, row) => {
        return (
          <div className="break-duration-cell">
            <span className="duration-value">{row?.duration} minutes</span>
          </div>
        );
      },
    },
    // {
    //   dataField: "shift_type",
    //   text: <p className="table__header">Shift Type</p>,
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="shift-type-badge">
    //         {formatShiftType(row?.shift_type)}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "status",
      text: <p className="table__header">Status</p>,
      formatter: (cell, row) => {
        const isActive = row?.status === "active";
        return (
          <span
            className="tb-data break-status-badge"
            style={{
              background: isActive ? "#28a745" : "#dc3545",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
              textTransform: "uppercase",
            }}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: <p className="table__header">Date Added</p>,
      formatter: (cell, row) => {
        return (
          <div className="break-date-cell">
            <p className="tb-data table__Text">
              {row?.date_added
                ? moment(row.date_added).format("DD-MM-YYYY")
                : "-"}
            </p>
            <small className="date-time">
              {row?.date_added ? moment(row.date_added).format("hh:mm A") : ""}
            </small>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn danger"
            onClick={() => onEditBreak && onEditBreak(row)}
            title="Edit Break Rule"
          >
            <EditIcon />
          </button>
          <button
            className="actionBtn danger ml-2"
            onClick={() => handleDelete(row?.uid, row?.name)}
            title="Delete Break Rule"
          >
            <DeleteIcon />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="break-rules-container">
      <Container className="bg-cloud-k gobal-container" fluid>
        {/* <Row>
          <Col>
            <CommonStructured
              pageHeading={"Break Rules Management"}
              subHeading={
                "Manage break rules for different shift types and durations"
              }
              createBtnTxt={"Create Break"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "create",
                  rowData: null,
                }))
              }
              isReload={() => refetchBreakRules()}
            />
          </Col>
        </Row> */}

        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table break-table-container">
          {breakRulesLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableColumns={breakRulesColumns}
              tableData={breakRulesData?.data}
              tablePagination={breakRulesData?.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
              isFirstColSticky={true}
            />
          )}
        </div>

        {breakRulesData?.data?.length === 0 && !breakRulesLoading && (
          <div className="break-empty-state">
            <div className="empty-icon">📋</div>
            <h5>No Break Rules Found</h5>
            <p>Click "Create New" to add your first break rule.</p>
          </div>
        )}
      </Container>
    </div>
  );
};

export default BreakRules;
